import { useRollbar } from "@rollbar/react";

// Small wrapper for logger
export const Logger = () => {
  return useRollbar();
};
